module.exports = __webpack_public_path__ + "static/our-mission-shape1-e51bbbe0e1614cbd48767dbb134aa8bb.png";